/*
  THAANI — Geschichte: Scroll-Reveals

  Vergibt 'is-in-view', sobald ein markiertes Element sichtbar wird.
  Wichtig: Die Startwerte der Animationen haengen an 'is-armed', die erst
  dieses Skript setzt. Ohne JS oder bei reduzierter Bewegung bleibt damit
  alles im Endzustand stehen — nichts bleibt unsichtbar haengen.

  Glas-Vergleich: Werte mit data-g-zahl zaehlen beim Einblenden von 0 hoch,
  im Takt der Fuellung (3 s je Glas, data-g-n Schichten, Schicht data-g-k).
  Mit data-g-wiederholen (Sekunden) laufen die Glaeser danach kurz aus
  ('is-leeren') und fuellen sich neu, aber nur, solange sie sichtbar sind.

  Mehrere Geschichte-Sections binden das Skript ein; es laeuft nur einmal.
*/

(function () {
  if (window.thaaniGeschichteReveal) return;
  window.thaaniGeschichteReveal = true;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  const targets = document.querySelectorAll('[data-g-reveal]');
  if (targets.length === 0) return;

  const GLAS_DAUER = 3000;
  const GLAS_LEEREN = 1200;
  const GLAS_MINDESTABSTAND = 8000;

  // gleiche Kurve wie die Fuellung im CSS: langsam an, langsam aus
  const kurve = (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);

  const zaehlen = (zahl, schritt) => {
    const ziel = Number(zahl.dataset.gZahl) || 0;
    const start = performance.now() + (Number(zahl.dataset.gK) || 0) * schritt;
    const tick = (jetzt) => {
      const t = Math.min(1, Math.max(0, (jetzt - start) / schritt));
      zahl.textContent = Math.round(ziel * kurve(t)) + ' %';
      if (t < 1) window.requestAnimationFrame(tick);
    };
    window.requestAnimationFrame(tick);
  };

  const einblenden = (element) => {
    element.classList.remove('is-leeren');
    element.classList.add('is-in-view');
    const schritt = GLAS_DAUER / (Number(element.dataset.gN) || 1);
    element.querySelectorAll('[data-g-zahl]').forEach((zahl) => {
      zahl.textContent = '0 %';
      zaehlen(zahl, schritt);
    });
  };

  const neuFuellen = (element) => {
    element.classList.remove('is-in-view');
    element.classList.add('is-leeren');
    window.setTimeout(() => {
      einblenden(element);
      takt(element);
    }, GLAS_LEEREN);
  };

  // naechster Durchgang; ist das Glas gerade nicht sichtbar, wartet er, bis es wieder ins Bild kommt
  const takt = (element) => {
    const abstand = Math.max(GLAS_MINDESTABSTAND, (Number(element.dataset.gWiederholen) || 0) * 1000);
    window.setTimeout(() => {
      if (element.gSichtbar) {
        neuFuellen(element);
      } else {
        element.gWartet = true;
      }
    }, abstand - GLAS_LEEREN);
  };

  targets.forEach((element) => {
    element.classList.add('is-armed');
    element.querySelectorAll('[data-g-zahl]').forEach((zahl) => {
      zahl.textContent = '0 %';
    });
  });

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const element = entry.target;
        const wiederholen = 'gWiederholen' in element.dataset;
        element.gSichtbar = entry.isIntersecting;
        if (!entry.isIntersecting) return;

        if (!element.gGestartet) {
          element.gGestartet = true;
          einblenden(element);
          if (wiederholen) {
            takt(element);
          } else {
            observer.unobserve(element);
          }
        } else if (element.gWartet) {
          element.gWartet = false;
          neuFuellen(element);
        }
      });
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.25 }
  );

  targets.forEach((element) => observer.observe(element));
})();
